import { Component, OnInit } from '@angular/core';
import { BaseComponent, BaseDataService, BaseUpdateComponent, NotificationService } from 'yt-ng-framework'
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Nacija } from './nacija';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-nacija-update',
  templateUrl: './nacija-update.component.html'
})
export class NacijaUpdateComponent 
extends BaseUpdateComponent<Nacija> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'NACIJA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(50), 'maxlength', 'NACIJA.NAZIV.VALIDATION.MAXLENGTH');

  }

}
